<template>
  <el-select
    v-model="currentValue"
    :placeholder="placeholder"
    :clearable="clearable"
    :size="size"
    :style="{ width: '100%' }"
    :filterable="filterable"
    :disabled="disabled"
  >
    <el-option
      v-if="defaultItem"
      :label="defaultItem.label"
      :value="defaultItem.id"
    />
    <el-option
      v-for="item in dataList"
      :key="item.id"
      :label="item.dictName"
      :value="item.dictValue"
    />
  </el-select>
</template>
<script>
export default {
  name: "DictDropdown",
  props: {
    disabled:{
      type:Boolean,
      default:false,
    },
    value: {
      type: String | Number,
      default: null,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    size: {
      type: String,
      default: "mini",
    },
    dictName: {
      type: String,
      default: "",
    },
    defaultItem: {
      type: Object,
      default: () => {
        return {
          id: "",
          label: "请选择",
        };
      },
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    autoSel: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataList: [],
    };
  },
  computed: {
    currentValue: {
      get() {
        if (this.value === null || this.value === undefined) {
          return "";
        }
        return String(this.value);
      },
      set(newVal) {
        this.$emit("input", newVal);
        this.$emit("change", newVal);
        this.$emit("changed", this.dataList.find((item) => item.dictValue === newVal));
      },
    },
  },
  created() {
    this.getDataList();
  },
  methods: {
    getDataList() {
      if (!this.dictName) {
        return;
      }
      this.$http
        .get(`/sys/dict/list/${this.dictName}`, {
          params: { dictType: this.dictName },
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataList = res.data;
            if (res.data && this.autoSel) {
              this.currentValue = res.data[0].dictValue;
            }
          }
        });
    },
    changeHandle(e) {
      this.$emit("input", e);
    },
  },
};
</script>
